import { Link } from 'react-router-dom';
import { Gift, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-border/50 bg-muted/20 mt-auto">
      <div className="container mx-auto px-4 py-12 md:py-16">
        {/* Main Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Gift className="w-6 h-6 text-primary" />
              <span className="text-lg font-bold tracking-tight">Budgetter</span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Der intelligenteste Geschenkfinder Deutschlands. Finde das perfekte Geschenk in unter 2 Minuten.
            </p>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <MapPin className="w-3.5 h-3.5" />
              <span>Deutschland</span>
            </div>
          </div>

          {/* Entdecken */}
          <div>
            <h3 className="font-semibold text-sm mb-4">Entdecken</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/questionnaire" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Geschenk-Finder
                </Link>
              </li>
              <li>
                <Link to="/geschenkideen" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Geschenkideen
                </Link>
              </li>
              <li>
                <Link to="/produkte" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Produkte
                </Link>
              </li>
              <li>
                <Link to="/magazin" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Magazin
                </Link>
              </li>
            </ul>
          </div>

          {/* Unternehmen */}
          <div>
            <h3 className="font-semibold text-sm mb-4">Unternehmen</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/ueber-uns" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="font-semibold text-sm mb-4">Rechtliches</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/impressum" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <a 
                  href="/sitemap.xml"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Sitemap
                </a>
              </li>
              <li>
                <button
                  onClick={() => {
                    try {
                      // Google Funding Choices API für AdSense CMP
                      const googlefc = (window as any).googlefc;
                      if (googlefc?.callbackQueue) {
                        googlefc.callbackQueue.push({
                          CONSENT_DATA_READY: () => {
                            googlefc.showRevocationMessage();
                          }
                        });
                      } else if ((window as any).__tcfapi) {
                        // Fallback: TCF API v2
                        (window as any).__tcfapi('displayConsentUi', 2, () => {});
                      } else {
                        console.log('CMP not loaded yet');
                      }
                    } catch (error) {
                      console.error('CMP dialog error:', error);
                    }
                  }}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors text-left"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Affiliate Hinweis */}
        <div className="border-t border-border/50 pt-6 pb-4">
          <p className="text-xs text-muted-foreground/70 text-center max-w-2xl mx-auto">
            Als Amazon-Partner verdienen wir an qualifizierten Käufen. Unsere Empfehlungen sind unabhängig und basieren auf objektiven Kriterien.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border/50 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Budgetter. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-muted-foreground">
            Made with ❤️ in Germany
          </p>
        </div>
      </div>
    </footer>
  );
};
